module.exports = __webpack_public_path__ + "static/media/landing-bottom-person.376bed0b.png";